import _ from 'lodash';
import { Box } from './Box';
import { Move } from './Move';

export class Column {
  index;
  items;

  constructor (index, items) {
    this.index = Math.round(index);
    this.items = items;
  }
}

export class ColumnItem extends Move {
  box;
  pointBox;
  pointPosition;
  position;
  label;
  backup;
  id;
  collidedWith;

  constructor (label, position, pointPosition, bbox) {
    super();
    this.id = this.guid();
    this.collidedWith = [];
    let pointX = 9;
    let pointY = 6;

    this.label = label;
    this.position = position;
    this.pointPosition = pointPosition;
    this.box = new Box(
      bbox.origin.x,
      bbox.origin.x + bbox.size.width,
      bbox.origin.y,
      bbox.origin.y + bbox.size.height);
    this.pointBox = new Box(
      bbox.origin.x + (bbox.size.width / 2),
      bbox.origin.x + pointX + 4,
      bbox.origin.y + pointY,
      bbox.origin.y + pointY + 4);

    this.backup = {
      position: position,
      pointPosition: pointPosition,
      box: this.box,
      pointBox: this.pointBox
    };

    this.restore = this.restore.bind(this);
  }

  restore () {
    this.position = this.backup.position;
    this.pointPosition = this.backup.pointPosition;
    this.box = this.backup.box;
    this.pointBox = this.backup.pointBox;
  }

  addCollision (collided) {
    if (collided.length) {
      this.collidedWith = this.collidedWith.concat(_.differenceBy(collided, this.collidedWith, 'id'));
    }
  }

  reorderLabels () {
    if (this.collidedWith.length) {
      const itemsCollided = _.uniqBy(this.collidedWith, d => d.id); // uniqBy fix duplicate elements bug
      itemsCollided.push(this);

      const itemsOriginalPosition = _.reverse(_.orderBy(itemsCollided, ['backup.box.y1']));
      const itemsFinalPosition = _.reverse(_.orderBy(itemsCollided, ['box.y1']));
      let boxesFinalPosition = itemsFinalPosition.map(item => _.cloneDeep(item.box));
      boxesFinalPosition.push(_.cloneDeep(this.box));
      boxesFinalPosition = _.orderBy(boxesFinalPosition, ['box.y1']);
      for (let i = 0; itemsOriginalPosition.length > i; i++) {
        itemsOriginalPosition[i].box = boxesFinalPosition[i];
        this.setTextPositionY(itemsOriginalPosition[i].label, boxesFinalPosition[i]);
        this.setPathPositionY(itemsOriginalPosition[i].label, boxesFinalPosition[i]);
      }

      // const itemsAsc = _.filter(itemsCollided, (item) => item.isAsc);
      // const itemsAscOrdered = _.reverse(_.orderBy(itemsAsc, ['backup.box.y1']));
      // const boxesPositionAsc = _.reverse(_.orderBy(itemsAsc, ['box.y1'])).map(item => _.cloneDeep(item.box));
      // for (let i = 0; itemsAscOrdered.length > i; i++) {
      //     itemsAscOrdered[i].box = boxesPositionAsc[i];
      //     this.setTextPositionY(itemsAscOrdered[i].label, boxesPositionAsc[i]);
      //     this.setPathPositionY(itemsAscOrdered[i].label, boxesPositionAsc[i]);
      // }
      //
      // const itemsDesc = _.filter(itemsCollided, (item) => !item.isAsc);
      // const itemsDescOrdered = _.orderBy(itemsDesc, ['backup.box.y1']);
      // const boxesPositionDesc = _.orderBy(itemsDesc, ['box.y1']).map(item => _.cloneDeep(item.box));
      // for (let i = 0; itemsDescOrdered.length > i; i++) {
      //     itemsDescOrdered[i].box = boxesPositionDesc[i];
      //     this.setTextPositionY(itemsDescOrdered[i].label, boxesPositionDesc[i]);
      //     this.setPathPositionY(itemsDescOrdered[i].label, boxesPositionDesc[i]);
      // }
    }
  }

  guid () {
    function s4 () {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }
}
